"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExercisesList = exports.TABS_DATA = void 0;
const react_1 = __importStar(require("react"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const apiFetch_1 = require("@app/utils/apiFetch");
const ExercisesList_elements_1 = require("./ExercisesList.elements");
const common_1 = require("@components/common");
const articulation_svg_1 = __importDefault(require("@components/icons/articulation.svg"));
const motor_svg_1 = __importDefault(require("@components/icons/motor.svg"));
const sound_svg_1 = __importDefault(require("@components/icons/sound.svg"));
const speechDev_svg_1 = __importDefault(require("@components/icons/speechDev.svg"));
const slogavaya_structure_svg_1 = __importDefault(require("@components/icons/slogavaya_structure.svg"));
const logic_cognitive_skills_svg_1 = __importDefault(require("@components/icons/logic_cognitive_skills.svg"));
const social_everyday_skills_svg_1 = __importDefault(require("@components/icons/social_everyday_skills.svg"));
const vocational_skills_svg_1 = __importDefault(require("@components/icons/vocational_skills.svg"));
const buttons_1 = require("@components/buttons");
const ExercisesList_translations_1 = require("./ExercisesList.translations");
const framedModules = new Set([
    "sound",
    "speech",
    "slogovaya_structure",
    "social_everyday_skills",
    "logic_cognitive_skills",
    "motor",
    "vocational_skills",
]);
const defaultTabs = new Set([
    "speech",
    "slogovaya_structure",
    "logic_cognitive_skills",
    "social_everyday_skills",
    "motor",
    "vocational_skills"
]);
exports.TABS_DATA = [
    {
        icon: react_1.default.createElement(articulation_svg_1.default, null),
        slug: "articulation",
    },
    {
        icon: react_1.default.createElement(motor_svg_1.default, null),
        slug: "motor",
    },
    {
        icon: react_1.default.createElement(sound_svg_1.default, null),
        slug: "sound",
    },
    {
        icon: react_1.default.createElement(speechDev_svg_1.default, null),
        slug: "speech",
    },
    {
        icon: react_1.default.createElement(slogavaya_structure_svg_1.default, null),
        slug: "slogovaya_structure"
    },
    {
        icon: react_1.default.createElement(social_everyday_skills_svg_1.default, null),
        slug: "social_everyday_skills"
    },
    {
        icon: react_1.default.createElement(logic_cognitive_skills_svg_1.default, null),
        slug: "logic_cognitive_skills"
    },
    {
        icon: react_1.default.createElement(vocational_skills_svg_1.default, null),
        slug: "vocational_skills"
    }
];
const ExercisesList = ({}) => {
    var _a;
    const [activeTab, setActiveTab] = (0, react_1.useState)("articulation");
    const [content, setContent] = (0, react_1.useState)({});
    const [popup, setPopup] = (0, react_1.useState)(null);
    const [language, setLanguage] = (0, react_1.useState)("en");
    const [tabsData, setTabsData] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        (0, apiFetch_1.apiFetch)('/groups')
            .then((response) => response.json())
            .then(response => {
            const langMap = { 1: "ru", 2: "en", 5: "uz", 6: "kz" };
            const langId = js_cookie_1.default.get("lang_id");
            setLanguage(langMap[langId] || "en");
            const query = new URLSearchParams(window.location.search);
            const group = query.get("group");
            if (response.map((tab) => tab.slug).includes(group)) {
                setActiveTab(group);
            }
            setTabsData(response.map(tab => {
                var _a;
                return (Object.assign(Object.assign({}, tab), { icon: ((_a = exports.TABS_DATA === null || exports.TABS_DATA === void 0 ? void 0 : exports.TABS_DATA.find(item => (item === null || item === void 0 ? void 0 : item.slug) === (tab === null || tab === void 0 ? void 0 : tab.slug))) === null || _a === void 0 ? void 0 : _a.icon) || '' }));
            }));
        });
    }, []);
    // useLayoutEffect(() => {
    //     const langId = Cookies.get("lang_id");
    //     setLanguage(Number(langId) === 1 ? "ru" : "en");
    //
    //     const query = new URLSearchParams(window.location.search);
    //     const group = query.get("group");
    //
    //     if (TABS_DATA.map((tab) => tab.slug).includes(group)) {
    //         setActiveTab(group);
    //     }
    // }, []);
    (0, react_1.useEffect)(() => {
        (0, apiFetch_1.apiFetch)(`/exercises/list/?group=${activeTab}&language=${language}`)
            .then((response) => response.json())
            .then((response) => {
            setContent((prevState) => {
                const update = {};
                update[activeTab] = response[0];
                return Object.assign(Object.assign({}, prevState), update);
            });
        });
    }, [activeTab, language]);
    const processExercises = (exercises) => exercises.map((exercise) => (react_1.default.createElement(ExercisesList_elements_1.Exercise, { key: exercise.id, onClick: () => setPopup({
            title: exercise.exercise_translation.name,
            description: exercise.exercise_translation.description,
            slug: exercise.slug,
            video: exercise.video,
            template: exercise.template,
        }) }, exercise.exercise_translation.name)));
    const processCategory = (object, isFramed) => {
        const children = (object) => {
            if (object.exercises.length !== 0) {
                if (object.children.length !== 0) {
                    const categoriesAndExercises = object.children.map((category) => {
                        return processCategory(category, isFramed);
                    });
                    categoriesAndExercises.push(processExercises(object.exercises));
                    return categoriesAndExercises;
                }
                return processExercises(object.exercises);
            }
            else if (object.children.length !== 0) {
                return object.children.map((category) => {
                    return processCategory(category, isFramed);
                });
            }
        };
        return (react_1.default.createElement(common_1.Accordion, { key: object.title, title: object.title, isFramed: isFramed, open: false, hasExercises: object.exercises.length !== 0 && object.children.length === 0 }, children(object)));
    };
    const children = () => {
        const object = content[activeTab];
        if (!object)
            return "...";
        const hasExercises = object.exercises.length > 0;
        const hasCategories = object.categories.length > 0;
        const isSound = object.slug === "sound";
        const isFramedModule = framedModules.has(object.slug);
        if (hasExercises && hasCategories) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                object.categories.map((category) => processCategory(category, isSound)),
                processExercises(object.exercises)));
        }
        if (hasExercises)
            return processExercises(object.exercises);
        if (hasCategories) {
            return object.categories.map((category) => processCategory(category, isFramedModule));
        }
    };
    const exercisesWrapClass = (activeTab === "sound")
        ? "framed-categories"
        : (defaultTabs.has(activeTab))
            ? "default-categories"
            : "only-exercises";
    return (react_1.default.createElement(ExercisesList_elements_1.ExercisesListWrap, null,
        react_1.default.createElement(common_1.Tabs, { activeTab: activeTab, tabs: tabsData, language: language, onChange: (tab) => setActiveTab(tab) }),
        react_1.default.createElement(ExercisesList_elements_1.Content, null,
            react_1.default.createElement("h1", null, (_a = tabsData === null || tabsData === void 0 ? void 0 : tabsData.find(item => (item === null || item === void 0 ? void 0 : item.slug) === activeTab)) === null || _a === void 0 ? void 0 : _a[`description_${language}`]),
            react_1.default.createElement(ExercisesList_elements_1.ExercisesWrap, { className: exercisesWrapClass }, children()),
            activeTab === "articulation" && (react_1.default.createElement("a", { href: "/exercises/calibrate" },
                react_1.default.createElement(buttons_1.Button, { variant: "rounded" }, ExercisesList_translations_1.t[language].calibration)))),
        react_1.default.createElement(common_1.PopUp, { className: "list-exercises-popup", open: !!popup, title: popup === null || popup === void 0 ? void 0 : popup.title, description: popup === null || popup === void 0 ? void 0 : popup.description, onClose: () => setPopup(null) },
            react_1.default.createElement("video", { controls: true, controlsList: "nodownload", id: "videoEx", className: "videoForPresentation", muted: true, style: {
                    width: "232px",
                    minHeight: "437px",
                    borderRadius: "20px",
                    paddingTop: "25px",
                }, src: popup === null || popup === void 0 ? void 0 : popup.video }),
            isPatient && (react_1.default.createElement(ExercisesList_elements_1.OpenExerciseButton, { href: (popup === null || popup === void 0 ? void 0 : popup.template) ? `${popup.template}${popup.slug}` : `/exercises/performing_exercise/${popup === null || popup === void 0 ? void 0 : popup.slug}` }, ExercisesList_translations_1.t[language].open_exercise)))));
};
exports.ExercisesList = ExercisesList;
